export default {"src":"/_next/static/media/green-logo-round.06aa73e1.svg","height":37,"width":37};